<template>
    <div id='cooperationProposal'>
        <!------------------------------聯絡我們開始------------------------------>
        <section class="cm-cooperationProposal-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>


            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('footer.CooperationProposal.Title')}}
                </div>
            </div>

            
            <form>
                <div class="cm-cooperationProposal-container">
                    <div class="mb-3 cm-cooperationProposal-msg">
                        {{$t('footer.CooperationProposal.Message')}}
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5" >
                            {{$t('footer.CooperationProposal.Form.Name')}}
                            <span class="text-danger" v-if="namePromptString !== ''">{{namePromptString}}</span>
                        </label>
                        <div class="col-sm-9">
                            <input v-model="inputName" v-on:blur="nameInputMonitor" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">
                            {{$t('footer.CooperationProposal.Form.Company')}}
                            <span class="text-danger" v-if="companyPromptString !== ''">{{companyPromptString}}</span>
                        </label>
                        <div class="col-sm-9">
                            <input v-model="inputCompany" v-on:blur="companyInputMonitor" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">
                            {{$t('footer.CooperationProposal.Form.CompanyAddress')}}
                            <span class="text-danger" v-if="companyAddressPromptString !== ''">{{companyAddressPromptString}}</span>
                        </label>
                        <div class="col-sm-9">
                            <input v-model="inputCompanyAddress" v-on:blur="companyAddressInputMonitor" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">{{$t('footer.CooperationProposal.Form.ContactNumber1')}}</label>
                        <div class="col-sm-9">
                            <input v-model="inputContactNumber1" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">{{$t('footer.CooperationProposal.Form.ContactNumber2')}}</label>
                        <div class="col-sm-9">
                            <input v-model="inputContactNumber2" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">{{$t('footer.CooperationProposal.Form.FAX')}}</label>
                        <div class="col-sm-9">
                            <input v-model="inputFax" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">
                            {{$t('footer.CooperationProposal.Form.Email')}}
                            <span class="text-danger" v-if="emailPromptString !== ''">{{emailPromptString}}</span>
                        </label>
                        <div class="col-sm-9">
                            <input v-model="inputEmail" v-on:blur="emailInputMonitor" type="text" class="form-control-plaintext cm-cooperationProposal-contactus-input">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">
                            {{$t('footer.CooperationProposal.Form.Type')}}
                            <span class="text-danger" v-if="typeSeriesPromptString !== ''">{{typeSeriesPromptString}}</span>
                        </label>
                        <div class="col-sm-9 d-flex">
                            <div v-for="(obj, objName) in typeSeries" :key="objName" class="col-4 pl-0 d-flex align-items-center">
                                <span class="pr-2">
                                    <input type="checkbox" class="cm-cooperationProposal-type-checkbox"
                                           :id="objName" :value="objName"
                                           @change="typeSeriesMonitor(obj)" v-model="obj.active">
                                </span>
                                {{obj.display}}
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label pl-sm-5">
                            {{$t('footer.CooperationProposal.Form.ProposalContent')}}
                            <span class="text-danger" v-if="proposalContentPromptString !== ''">{{proposalContentPromptString}}</span>
                        </label>
                        <div class="col-sm-9">
                            <textarea v-model="inputProposalContent" v-on:blur="proposalContentInputMonitor" class="form-control rounded-0" rows="5"></textarea>
                        </div>
                    </div>
                    <div v-if="domControl.isWaitingEmailSend==true" class="d-flex justify-content-center">
                        <div class="col-3"></div>
                        <div class="spinner-border  text-warning" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-3"></div>
                        <div class="col-sm-9 d-flex justify-content-around">
                            <a href="#" @click="submiit" class="cm-cooperationProposal-send-btn">{{$t('footer.CooperationProposal.Form.Confirm.Btn')}}</a>
                            <a href="#" @click="reset" class="cm-cooperationProposal-send-btn">{{$t('footer.CooperationProposal.Form.Reset.Btn')}}</a>
                        </div>
                    </div>
                </div>
            </form>
            
            <br/>
            <div class="cm-cooperationProposal-banner-line"></div>
        </section>
        <!------------------------------聯絡我們結束------------------------------>
    </div>
</template>

<script>
import axios from "axios";
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'
export default {
    data() {
        return {
            inputName: "",
            namePromptString: "",
            inputCompany: "",
            companyPromptString: "",
            inputCompanyAddress: "",
            companyAddressPromptString: "",
            inputContactNumber1: "",
            inputContactNumber2: "",
            inputFax: "",
            inputEmail: "",
            emailPromptString: "",
            inputProposalContent: "",
            proposalContentPromptString: "",
            typeSeries: { // 提案類型
                MarketingCooperation: {
                    display: this.$i18n.t('footer.CooperationProposal.Form.Type.Checkbox.MarketingCooperation'),
                    value: 'MarketingCooperation',
                    active: false
                },
                Authorization: {
                    display: this.$i18n.t('footer.CooperationProposal.Form.Type.Checkbox.Authorization'),
                    value: 'Authorization',
                    active: false
                },
                Others: {
                    display: this.$i18n.t('footer.CooperationProposal.Form.Type.Checkbox.Others'),
                    value: 'Others',
                    active: false
                }
            },
            typeSeriesPromptString: "",
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            domControl: {
                isWaitingEmailSend: false
            }
        }
    },
    mounted() {
        this.updateTopBackgroundImg();
        document.documentElement.scrollTop = 0;

        // 更換語言時候
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_COOPERATION_PROPOSAL, function(i18n) {
            self.updateTopBackgroundImg(i18n);
            self.typeSeries.MarketingCooperation.display = i18n.t('footer.CooperationProposal.Form.Type.Checkbox.MarketingCooperation')
            self.typeSeries.Authorization.display = i18n.t('footer.CooperationProposal.Form.Type.Checkbox.Authorization')
            self.typeSeries.Others.display = i18n.t('footer.CooperationProposal.Form.Type.Checkbox.Others')
        })
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        async nameInputMonitor() {
            const self = this;
            return new Promise(function(resolve) {
                self.inputName=="" ? self.namePromptString="*" : self.namePromptString="";
                resolve();
            })
        },
        async companyInputMonitor() {
            const self = this;
            return new Promise(function(resolve) {
                self.inputCompany=="" ? self.companyPromptString="*" : self.companyPromptString="";
                resolve();
            })
        },
        async companyAddressInputMonitor() {
            const self = this;
            return new Promise(function(resolve) {
                self.inputCompanyAddress=="" ? self.companyAddressPromptString="*" : self.companyAddressPromptString="";
                resolve();
            })
        },
        async emailInputMonitor() {
            const self = this;
            return new Promise(function(resolve) {
                if(self.inputEmail=="") {
                    self.emailPromptString = "*"
                }
                else {
                    const errorMsg = ValidatorUtil.validEmail(self.inputEmail);
                    errorMsg!="" ? self.emailPromptString = "*" : self.emailPromptString = "";
                }
                resolve();
            })
        },
        async typeSeriesMonitor(selectedItem) { // 提案類型
            return new Promise((resolve) => {
                let items = Object.values(this.typeSeries);
                if(selectedItem == undefined) { // submit前檢查
                    let isItemActive = false;
                    items.forEach(obj => {
                        if(obj.active == true) {
                            isItemActive = true;
                        }
                    })
                    if(!isItemActive) {
                        this.typeSeriesPromptString = "*";
                    }
                    isItemActive == false ? this.typeSeriesPromptString="*" : this.typeSeriesPromptString = "";
                }
                else {
                    if (selectedItem.active) { // 已勾選
                        this.typeSeriesPromptString = "";
                        // 清除其他已勾選項目
                        items.forEach(obj => {
                            if (obj.display != selectedItem.display) {
                                obj.active = false;
                            }
                        })
                    }
                    else { // 未勾選
                        this.typeSeriesPromptString = "*";
                    }
                }
                resolve();
            })
        },
        async proposalContentInputMonitor() {
            const self = this;
            return new Promise(function(resolve) {
                self.inputProposalContent=="" ? self.proposalContentPromptString="*" : self.proposalContentPromptString="";
                resolve();
            })
        },
        async submiit() {
            // 檢查是否有值未填寫
            await this.nameInputMonitor();
            await this.companyInputMonitor();
            await this.companyAddressInputMonitor();
            await this.emailInputMonitor();
            await this.typeSeriesMonitor();
            await this.proposalContentInputMonitor();
            if(this.namePromptString!="" || this.companyPromptString!="" 
              || this.companyAddressPromptString!="" || this.emailPromptString!="" 
              || this.proposalContentPromptString!="" || this.typeSeriesPromptString!="") {
                return ;
            }
            
            const self = this;
            let bodyFormData = new FormData();
            bodyFormData.append("name", this.inputName);
            bodyFormData.append("company", this.inputCompany);
            bodyFormData.append("companyAddress", this.inputCompanyAddress);
            bodyFormData.append("contactNumber1", this.inputContactNumber1);
            bodyFormData.append("contactNumber2", this.inputContactNumber2);
            bodyFormData.append("fax", this.inputFax);
            bodyFormData.append("email", this.inputEmail);
            bodyFormData.append("proposalContent", this.inputProposalContent);
            
            // type
            let type = "";
            for(const itemName in this.typeSeries) {
                const item = this.typeSeries[itemName];
                if(item.active) {
                    type = item.value;
                }
            }
            bodyFormData.append("type", type);

            this.domControl.isWaitingEmailSend = true
            await axios({
                method: "post",
                timeout: 20000,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/sendCooperationAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                if(response.data.result == "success") {
                    alert(self.$i18n.t('footer.CooperationProposal.Form.Return.Success'));
                }
                else {
                    alert(self.$i18n.t('footer.CooperationProposal.Form.Return.Failed'));
                }
            })
            .catch(function(response) {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
            })
            this.domControl.isWaitingEmailSend = false
        },
        reset() {
            this.inputName = ""
            this.namePromptString = ""
            this.inputCompany = ""
            this.companyPromptString = ""
            this.inputCompanyAddress = ""
            this.companyAddressPromptString = ""
            this.inputContactNumber1 = ""
            this.inputContactNumber2 = ""
            this.inputFax = ""
            this.inputEmail = ""
            this.emailPromptString = ""
            this.inputProposalContent = ""
            this.proposalContentPromptString = ""
            this.typeSeriesPromptString = ""
            
            // 清除勾選的提案類型
            let items = Object.values(this.typeSeries);
            items.forEach(obj => {
                obj.active = false
            })
        }
    }
}
</script>